import fb from '@/firebase'
import store from '@/store'
import request from '@/request'
import router from '@/router'

const state = { }

const getters = { }

const mutations = { }

const actions = {
  signInWithGoogle ({commit}, payload) {
    store.dispatch('setLoaderStatus', true)
    fb.signInWithGoogle()
      .then((result) => {
        store.dispatch('setLoaderStatus', false)
      }).catch(err => store.dispatch('setLoaderStatus', false))
  },
  signInWithEmail ({commit}, payload) {
    store.dispatch('setLoaderStatus', true)
    fb.signInWithEmail(payload)
      .then(user => {
        store.dispatch('setLoaderStatus', false)
      }).catch(err => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setErrorMessage', 'User does not exists on this email')
      })
  },
  signUpWithEmail ({commit}, payload) {
    store.dispatch('setLoaderStatus', true)
    fb.createUserWithEmailAndPassword(payload.email, payload.password)
      .then(async user => {
        if (user) {
          delete payload['password']
          if (payload.type === 'Student') {
            const response = await request.getNextUserID(payload.email)
            response.json().then(data => {
              payload['seq_id'] = data.next_id
              fb.setUserBasicDetails(user.uid, payload)
                .then(() => {
                  store.dispatch('setLoaderStatus', false)
                  store.dispatch('getUser', user.uid)
                  router.push('/student')
                })
            }).catch(error => {
              store.dispatch('setLoaderStatus', false)
              store.dispatch('setErrorMessage', "Some thing went wrong while updating basic details")
            })
          } else {
            fb.setUserBasicDetails(user.uid, payload)
              .then(() => {
                store.dispatch('setLoaderStatus', false)
                store.dispatch('getUser', user.uid)
              })
          }
        } else {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setErrorMessage', "Some thing went wrong")
        }
      }).catch(err => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setErrorMessage', err.message)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js